import { createRoute, lazyRouteComponent } from "@tanstack/react-router";
import { z } from "zod";

import { authenticatedRoute } from "../_authenticated.js";

const myVaultSearchSchema = z.object({
  workspaceId: z.string().uuid().optional().catch(undefined),
  partner: z.string().min(1).optional().catch(undefined),
  create: z.coerce.boolean().optional().catch(undefined),
});

export const myVaultRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/my-vault",
  validateSearch: (search: Record<string, unknown>) => myVaultSearchSchema.parse(search),
  component: lazyRouteComponent(() => import("./my-vault.page.js"), "MyVaultPage"),
});
